import { useCallback } from 'react';

import { useJobContext } from 'pages/Job/context';
import { scrollToTop } from 'utils';

export interface JobBackButtonHook {
  onBackClick: () => void;
}

export default function useJobBackButton(): JobBackButtonHook {
  const { page, goToPage, setPaymentType } = useJobContext();

  const onBackClick = useCallback(() => {
    if (page === 'QUOTE') return;
    if (page === 'CHECKOUT') {
      setPaymentType(undefined);
    }
    scrollToTop();
    const previous = page === 'CHECKOUT' ? 'QUOTE' : 'CHECKOUT';
    goToPage(previous);
  }, [goToPage, page, setPaymentType]);

  return {
    onBackClick,
  };
}
